import React from "react";
import { useFieldArray } from "react-hook-form";
import Button from "../../../../../components/Common/Button/Button";
import Input from "../../../../../components/Common/Input/Input";
import PlusIcon from "../../../../../components/Common/SvgIcons/CommonIcons/PlusIcon";
import UploadImageIcon from "../../../../../components/Common/SvgIcons/CommonIcons/UploadImageIcon";
import DeleteIcon from "../../../../../components/Common/SvgIcons/TableIcons/DeleteIcon";
import { setErrorHandler } from "../../../../../store/actions/actionHandlers/errorActionHandler";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { errorTypes } from "../../../../../utils/errorTypes";
import classes from "./AddQuizAnswers.module.scss";
import Tooltip from "../../../../../components/Common/ToolTip/Tooltip";
import { FormattedMessage } from "react-intl";

const AddQuizAnswers = ({
  activeQuestionIndex,
  control,
  activeTab,
  questionListWatch,
  handleThumbnailSelect,
  isDistributed,
  errors,
  quizInputVisible,
  disabeldFieldsViewPath,
  isImagesCheckbox,
  shotclassType,
  trigger,
  setValue,
}) => {
  const {
    fields: answersFields,
    append: appendAnswer,
    remove: removeAnswer,
  } = useFieldArray({
    control,
    name: `QuestionsList.${activeQuestionIndex}.AnswersList`,
  });
  const commonState = useSelector((state) => state.commonReducer);
  const { colors } = commonState;
  const dispatch = useDispatch();
  const handleappendNewAnswer = () => {
    if (answersFields.length < 4) {
      appendAnswer({ Answer: "", AnswerImage: "" });
    } else {
      dispatch(
        setErrorHandler(errorTypes.WARN, "Maximum 4 options are allowed"),
      );
    }
  };

  return activeTab === 1 ? (
    <div className={classes.AddQuizAnswers__answersFields}>
      {answersFields.map((item, index, ansArr) => {
        let isImageAdded =
          questionListWatch?.[activeQuestionIndex]?.AnswersList?.filter(
            (answer) => answer?.AnswerImage !== "",
          )?.length > 0;
        return (
          <div
            key={item.id}
            className={classes.AddQuizAnswers__answersFields__answerField}
          >
            <Input
              name={`QuestionsList.${activeQuestionIndex}.AnswersList.${index}.Answer`}
              label={`Answer ${index + 1}`}
              labelMsg={
                isImageAdded
                  ? `(Max : 60 Characters)`
                  : `(Max : 250 Characters)`
              }
              placeholder={
                isImageAdded ? `Answer ${index + 1}` : `Answer ${index + 1}`
              }
              labelColor={"light"}
              error={
                errors?.QuestionsList?.[activeQuestionIndex]?.AnswersList?.[
                  index
                ]?.Answer?.message
              }
              errorPosition="absolute"
              type="textarea"
              disabled={disabeldFieldsViewPath}
              maxLength={isImageAdded ? 60 : 250}
              onChange={() => {
                trigger([`QuestionsList.${activeQuestionIndex}.AnswersList`]);
              }}
            />
            <div
              className={
                classes.AddQuizAnswers__answersFields__answerField__radio
              }
            >
              <Input
                name={`QuestionsList.${activeQuestionIndex}.IsCorrect`}
                type="radio"
                width="2"
                height="2"
                value={`${index}`}
                disabled={disabeldFieldsViewPath}
              />
            </div>
            <Input
              key={item.id}
              type="file"
              name={`QuestionsList.${activeQuestionIndex}.AnswersList.${index}.AnswerImage`}
              placeholder=" "
              label="Add Image"
              labelColor={"light"}
              accept=".jpeg,.png,.bmp,.jpg"
              error={
                errors?.QuestionsList?.[activeQuestionIndex]?.AnswersList?.[
                  index
                ]?.AnswerImage?.message
              }
              errorPosition="absolute"
              hidden={true}
              fileInputIcon={UploadImageIcon}
              width={10}
              fileInputButtonWidth={8}
              disabled={disabeldFieldsViewPath}
              fileInputName={
                questionListWatch?.[activeQuestionIndex]?.AnswersList?.[index]
                  .AnswerImage?.FileName
              }
              handleCancelFileInput={() =>
                trigger([`QuestionsList.${activeQuestionIndex}.AnswersList`])
              }
              isImagesCheckbox
              handleClickFileButton={() => {
                handleThumbnailSelect(
                  `QuestionsList.${activeQuestionIndex}.AnswersList.${index}.AnswerImage`,
                );
              }}
              gap={
                // questionListWatch?.[activeQuestionIndex]?.AnswersList?.[index]
                //   ?.AnswerImage
                //   ? 1.5
                //   : 3.3\
                1.1
              }
            />
            {index !== 0 && !isDistributed && (
              <Tooltip content="Delete" direction="bottom">
                <span
                  onClick={() => {
                    if (shotclassType !== "view") {
                      removeAnswer(index);
                      const isCorrectIndex =
                        questionListWatch?.[activeQuestionIndex]?.IsCorrect;
                      if (isCorrectIndex && index <= isCorrectIndex) {
                        setValue(
                          `QuestionsList.${activeQuestionIndex}.IsCorrect`,
                          "",
                        );
                      }
                    }
                  }}
                  className={
                    classes.AddQuizAnswers__answersFields__answerField__removeIcon
                  }
                >
                  {!disabeldFieldsViewPath && (
                    <DeleteIcon fill={colors.theme} />
                  )}
                </span>
              </Tooltip>
            )}
            {index === ansArr.length - 1 &&
              !errors?.QuestionsList?.[activeQuestionIndex]?.AnswersList?.[
                index
              ]?.Answer?.message &&
              !errors?.QuestionsList?.[activeQuestionIndex]?.AnswersList?.[
                index
              ]?.AnswerImage?.message && (
                <div
                  className={
                    classes.AddQuizAnswers__answersFields__answerField__error
                  }
                >
                  {
                    // questionListWatchTemp?.[
                    //   activeQuestionIndex
                    // ]?.AnswersList?.filter((answer) => answer?.Answer !== "")
                    //   ?.length > 0 &&
                    // !errors?.QuestionsList?.message &&
                    errors?.QuestionsList?.[activeQuestionIndex]?.AnswersList
                      ?.message ||
                      errors?.QuestionsList?.[activeQuestionIndex]?.IsCorrect
                        ?.message
                  }
                </div>
              )}
          </div>
        );
      })}

      <div className={classes.AddQuizAnswers__answersFields__addMultiContainer}>
        <Button
          label="Add New"
          height="3"
          width="11.3"
          icon={PlusIcon}
          onClick={handleappendNewAnswer}
          // onClick={() => {
          //   appendAnswer({ Answer: "", AnswerImage: "" });
          // }}
          light
          type="button"
          disabled={disabeldFieldsViewPath || isDistributed}
        />
        <Input
          name={`QuestionsList.${activeQuestionIndex}.Explanation`}
          label={"Enter Answer Explanation (Optional)"}
          placeholder="Enter Answer Explanation Here"
          labelColor={"light"}
          disabled={disabeldFieldsViewPath}
          maxLength={250}
          error={
            errors?.QuestionsList?.[activeQuestionIndex]?.Explanation?.message
          }
          type="textarea"
        />
        {quizInputVisible === true && (
          <Input
            name={`QuestionsList.${activeQuestionIndex}.Duration`}
            label="Quiz Duration"
            placeholder="Enter Duration for the question in seconds"
            maxLength="4"
          />
        )}
      </div>
    </div>
  ) : activeTab === 2 ? (
    <div className={classes.AddQuizAnswers__trueOrFalse}>
      Select answer is true or false
      <div className={classes.AddQuizAnswers__trueOrFalse__fields}>
        <Input
          label={<FormattedMessage id="TRUE_TEXT" />}
          name={`QuestionsList.${activeQuestionIndex}.IsCorrect`}
          type="radio"
          width="2"
          height="2"
          value={"True"}
          direction={"row-reverse"}
          disabled={disabeldFieldsViewPath}
        />
        <Input
          label={<FormattedMessage id="FALSE_TEXT" />}
          name={`QuestionsList.${activeQuestionIndex}.IsCorrect`}
          type="radio"
          width="2"
          height="2"
          value={"False"}
          direction={"row-reverse"}
          disabled={disabeldFieldsViewPath}
        />
      </div>
      {/* <div>{errors?.IsCorrect?.message}</div> */}
      <div className={classes.AddQuizAnswers__trueOrFalse__error}>
        {errors?.QuestionsList?.[activeQuestionIndex]?.IsCorrect?.message}
      </div>
      <div className={classes.AddQuizAnswers__inputFields}>
        <Input
          name={`QuestionsList.${activeQuestionIndex}.Explanation`}
          label={"Enter Answer Explanation (Optional)"}
          placeholder="Enter Answer Explanation Here"
          labelColor={"light"}
          disabled={disabeldFieldsViewPath}
          error={
            errors?.QuestionsList?.[activeQuestionIndex]?.Explanation?.message
          }
          maxLength={250}
          type="textarea"
        />
        {quizInputVisible === true && (
          <Input
            name={`QuestionsList.${activeQuestionIndex}.Duration`}
            label="Quiz Duration"
            placeholder="Enter Duration for the question in seconds"
            maxLength="4"
            disabled={disabeldFieldsViewPath}
          />
        )}
      </div>
    </div>
  ) : (
    <></>
  );
};

export default AddQuizAnswers;
